

export default {
  async updateAddressForm({ commit }, payload = {}) {
    commit('SET_ADDRESS', payload)
  },
  async resetAddressForm({ commit }) {
    commit('RESET_ADDRESS')
  },
  async updateBillingAddressForm({ commit }, payload = {}) {
    commit('SET_BILLING_ADDRESS', payload)
  },
  async resetBillingAddressForm({ commit }) {
    commit('RESET_BILLING_ADDRESS')
  },
  async updatePaymentForm({ commit }, payload = {}) {
    commit('SET_PAYMENT_INFO', payload)
  },
  async resetPaymentForm({commit }) {
    commit('RESET_PAYMENT_INFO')
  },
  async updateContactForm({ commit }, payload = {}) {
    commit('SET_CONTACT', payload)
  },
  async resetContactForm({ commit }) {
    commit('RESET_CONTACT')
  },
  async updateItemAccepted({ commit }, payload = {}) {
    commit('SET_ITEM_ACCEPTED', payload)
  },
  async updateAnyAccepted({ commit }, payload = {}) {
    commit('SET_ANY_ACCEPTED', payload)
  },
  async setCheckoutSettings({ commit }, payload) {
    commit('SET_CHECKOUT_SETTINGS', payload)
  },
  async resetCheckout({ dispatch }) {
    dispatch('resetAddressForm')
    dispatch('resetBillingAddressForm')
    dispatch('resetPaymentForm')
    dispatch('resetContactForm')
  },
  async setTotalOrder({ commit }, payload) {
    commit('SET_TOTAL_ORDER', payload)
  }

}